import React, { useRef, useState } from "react"
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button,
    Media
} from "reactstrap";
// core components
import Header from "../../../components/headers/Header";
import MessageBox from "../../../components/ui/MessageBox";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { Upload } from "antd";
import "antd/dist/antd.css";

import * as Helper from "../../../utils/Helper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/course/EditRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import CourseEditService from "../../../services/screens/admin/course/EditService";
import "../../../assets/scss/screens/admin/unit/fields/types/uploadImage.scss";
import SearchImageOnline from "../../../components/ui/SearchImageOnline";
import UIDs from "../../../UIDs";

const uid = UIDs.screens.admin.course.edit;
const { Dragger } = Upload;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_COURSE_ASYNC]: { done: this._handleSaveCourseAsyncDone, error: this._handleAsyncActionError }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id, productId } = this.localVars.navParams;
        if (id)
            this.props.loadScreenViewAsync(id);
        else
            this.props.createCourse(productId);
    }

    render() {
        const { course, courseWithCategory } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!(course || courseWithCategory) || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    onCancel={this._handleCancelEdit}
                                    onSave={this._handleSaveCourse}
                                    isDisabled={this.isActionExecuting(ActionTypes.SAVE_COURSE_ASYNC)}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleSaveCourse = (data) => {
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        this.props.saveCourseAsync(data);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleCancelEdit = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleSaveCourseAsyncDone = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

function EditForm(props) {
    const {course, courseWithCategory, enableLearnFunction, categories } = props.localState;
    let id, productId, title, description, cover, level, category, cost;
    if(!enableLearnFunction &&  course !== null){
        id = course.id;
        productId = course.productId;
        title = course.title;
        description = course.description;
        cover = course.cover;
    } else if(enableLearnFunction && courseWithCategory !== null){
        id = courseWithCategory.id;
        productId = courseWithCategory.productId;
        title = courseWithCategory.title;
        description = courseWithCategory.description;
        cover = courseWithCategory.cover;
        level = courseWithCategory.level;
        category = courseWithCategory.category;
        cost = courseWithCategory.cost;
    }

    const { register, handleSubmit, errors, setValue } = useForm();
    const submitRef = useRef();

    // store all uploaded imagePath
    const [state_imagePath, setstate_imagePath] = useState(cover||"");

    // represent the image uploading button status
    const [state_imageLoading, setstate_imageLoading] = useState("");

    //粘贴图显示样式
    const [state_pastdivStyle, setstate_pastdivStyle] = useState("upLoadImage");

    const uploadImageProps = {
        name: "fileData",
        multiple: false,
        showUploadList: false, // set to only upload one file
        customRequest: info => {
            startUpload(info.file, "1", uploadImageSuccessCallback);
        },
        beforeUpload: file => {
            const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
            if (!isJpgOrPng) {
                MessageBox.danger({ text: props.t("uploadImageFormatLimited"), duration: 5000 });
                return false;
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isLt5M) {
                MessageBox.danger({ text: props.t("uploadImageSizeLimited", { fileSize: 5 }), duration: 5000 });
                return false;
            }
            return isJpgOrPng && isLt5M;
        }
    };

    const startUpload = (file, setStateVal, uploadSuccessCallback) => {
        setstate_imageLoading(setStateVal);
        CourseEditService.upload(
            file,
            response => {
                uploadSuccessCallback(response);
                setstate_imageLoading("");
            },
            error => {
                setstate_imageLoading("");
                MessageBox.danger({ text: error.message, duration: 5000 });
            }
        );
    };

    const uploadImageSuccessCallback = (data) => {
        const { virtualPath } = data;
        setstate_imagePath(virtualPath);
        setValue("cover", virtualPath);
    };

    const removeImage = (index) => {
        setstate_imagePath("");
        setValue("cover", "");
    };

    const upPastePic = (event) =>{
        var getFile = getPastePic(event);
        if(getFile){
            startUpload(getFile, "2", uploadImageSuccessCallback);
        }
    }

    const changePastStyle = (kind) =>{
        if (kind==="click") {
            setstate_pastdivStyle("upLoadImage choiceDiv");
        } else {
            setstate_pastdivStyle("upLoadImage");
        }
    }

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">{props.t("course")}</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            onClick={props.onCancel}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <input name="id" hidden type="text" className="form-control" defaultValue={id} ref={register} />
                    <input name="productId" hidden type="text" className="form-control" defaultValue={productId} ref={register} />
                    <div className="pl-lg-4">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="form-group">
                                <label className="form-control-label">{props.t("cover")}</label>
                            </div>
                        </div>
                    </div>
                    <div className="row uploadImageDiv">
                        <div className="col-lg-12">
                            <div className="form-group" style={{float:"left",marginRight:"20px"}}>
                                <Dragger {...uploadImageProps}>
                                    <div style={{textAlign:"center",marginTop:"-10px",marginBottom:"-10px",width:"300px",height:"62px"}}>
                                    {
                                        state_imageLoading === "1" ? <span><i className="fa fa-spinner fa-pulse" style={{fontSize:"50px", marginTop:"5px"}}></i></span>
                                        : <div>
                                            <i className="fa fa-inbox" style={{fontSize:"30px", color:"#11cdef"}}></i>
                                            <div style={{fontSize:"16px",marginTop:"5px",paddingLeft:"5px",paddingRight:"5px"}}>{props.t("uploadTitle")}</div>
                                        </div>
                                    }
                                    </div>
                                </Dragger>
                            </div>
                            <div style={{float:"left", marginRight:"20px",paddingTop:"30px"}}>
                                {props.t("or")}
                            </div>
                            <div className="form-group" style={{float:"left", marginRight:"20px"}} >
                            <div className={state_pastdivStyle} tabIndex="-1"
                                onFocus={(e) => { changePastStyle("click") }}
                                onBlur={(e) => { changePastStyle("outClick") }}
                                onPaste={(e) => { upPastePic(e) }} >
                                    {
                                        state_imageLoading === "2" ? <span><i className="fa fa-spinner fa-pulse" style={{fontSize:"50px", marginTop:"5px"}}></i></span>
                                        : <div style={{marginTop:"1px"}}>
                                            <i className="fa fa-paste" style={{fontSize:"30px", color:"#2dce89"}}></i>
                                            <div style={{fontSize:"16px",marginTop:"5px"}}>{props.t("pasteTitle")}</div>
                                        </div>
                                    }
                            </div>
                            </div>
                            <div style={{float:"left", marginRight:"20px",paddingTop:"30px"}}>
                                {props.t("or")}
                            </div>
                            <div>
                                <SearchImageOnline startUpload={startUpload} uploadSuccessCallback={uploadImageSuccessCallback} />
                            </div>
                        </div>
                        {state_imagePath !== "" ?
                            <div style={{marginLeft:"13px",marginTop:"-5px"}}>
                                <div className="imgList">
                                    <div style={{float:"left", cursor:"pointer"}}>
                                        <i className="fa fa-paperclip" aria-hidden="true" style={{marginRight:"5px"}}></i>
                                    </div>
                                    <a style={{float:"left"}} rel="noopener noreferrer nofollow" target="_blank" href={Helper.convertToFileServerPath(state_imagePath)}>
                                        {state_imagePath.substring(state_imagePath.lastIndexOf("/") +1 )}
                                    </a>
                                    <div style={{float:"right", cursor:"pointer"}} onClick={(e) => {removeImage()}}>
                                        <i className="fa fa-times" aria-hidden="true" style={{marginLeft:"10px", padding: "0px 10px"}}></i>
                                    </div>
                                </div>
                            </div>
                        : null}
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="form-group">
                                {state_imagePath !== "" ?
                                    <Media>
                                        <img src={Helper.convertToFileServerPath(state_imagePath)} alt="..." style={{ width: "200px", height: "180px" }} />
                                    </Media>
                                    : null}
                                <input name={"cover"} defaultValue={cover} ref={register} hidden readOnly type="text" className="form-control-alternative form-control" />                                
                            </div>
                        </div>
                    </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("title")}</label>
                                    <input name="title" type="text" className="form-control-alternative form-control" defaultValue={title} maxLength={100}
                                        ref={register({ required: true })} />
                                    {errors.title && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("description")}</label>
                                    <textarea name="description" rows="4" className="form-control-alternative form-control" defaultValue={description}
                                        ref={register} />
                                </div>
                            </div>
                        </div>
                        {enableLearnFunction ?
                            <>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-control-label">{props.t("cost")}</label>
                                            <input name="cost" type="text" className="form-control-alternative form-control" defaultValue={cost} maxLength={10}
                                                ref={register({ required: true })} />
                                            {errors.LearnBookVO && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-control-label">{props.t("level")}</label>
                                            <select name="level" ref={register} defaultValue={level} className="form-control-alternative form-control">
                                                <option value="1">{props.t("level1")}</option>
                                                <option value="2">{props.t("level2")}</option>
                                                <option value="3">{props.t("level3")}</option>
                                                <option value="4">{props.t("level4")}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-control-label">{props.t("category")}</label>
                                            <select name="category" ref={register} defaultValue={category} className="form-control-alternative form-control">
                                                {categories.map((item, index) => {
                                                    return <option value={item.id}>{item.name}</option>;
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : null
                        }
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

function getPastePic(event){
    var items = (event.clipboardData && event.clipboardData.items) || [];
    var file = null;
    if (items && items.length) {
        for (var i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") !== -1) {
                file = items[i].getAsFile();
                break;
            }
        }
    }

    return file;
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: id => dispatch(Actions.loadScreenViewAsync(id)),
        saveCourseAsync: vo => dispatch(Actions.saveCourseAsync(vo)),
        createCourse: (productId) => dispatch(Actions.createCourse(productId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));
